<template>
  <p>
    <template v-for="(item, i) in dimensionsBullets" :key="i">
      <span data-auto="product-dimensions-text">
        {{ `${item} ` }}
      </span>
    </template>
  </p>
</template>

<script setup>
import { useProductDetails } from '../composables/useProductDetails';

const { dimensionsBullets } = useProductDetails();
</script>
